import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SendFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M3.02 11.34L20.9 4.4L14.3 20.96L10.16 17.42L8.12 19.98L7.56 15.22L3.02 11.34Z" />
    </SvgIcon>
  );
});
